import {useEffect, useState} from "react";

// Sidebar do admin (#480058). 'responsive' (padrao do CoreUI): aberta no
// desktop e escondida no celular, onde o botao de menu do cabecalho abre por
// cima do conteudo. Estado unico para a sidebar e o cabecalho, sem Redux.
export type EstadoSidebar = boolean | 'responsive';

let estado: EstadoSidebar = 'responsive';
const ouvintes = new Set<(novo: EstadoSidebar) => void>();

export const definirSidebar = (novo: EstadoSidebar) => {
    estado = novo;
    ouvintes.forEach(ouvinte => ouvinte(novo));
};

/** Botao de menu do cabecalho (so aparece abaixo de lg). */
export const alternarSidebar = () => {
    definirSidebar(estado === true ? 'responsive' : true);
};

const useSidebar = (): EstadoSidebar => {
    const [atual, setAtual] = useState<EstadoSidebar>(estado);
    useEffect(() => {
        ouvintes.add(setAtual);
        return () => {
            ouvintes.delete(setAtual);
        };
    }, []);
    return atual;
};

export default useSidebar;
